import { Field } from 'redux-form';
import UploadFile from './UploadFile';

const Upload = (props) => {
  return <Field name={props.name} component={UploadFile} {...props} />;
}

export default Upload;